//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import { Navigate, Outlet } from 'react-router';
import { useAuth } from '@/hooks/useAuth';
import { useNavigationInvalidation } from '@/hooks/useNavigationInvalidation';
import { ERoutesRoot } from '@/routes/RoutesEnum';

const ProtectedRoute = () => {
  const { authStatus } = useAuth();

  // Every navigation between protected routes marks the datasets query stale
  // so the destination page arrives fresh (see the hook for the rationale).
  useNavigationInvalidation();

  // authStatus is the reactive source of truth for the auth gate, set by the
  // startup session restore (AppBootstrap) and by login/logout.  No restore is
  // triggered here — AppBootstrap is the sole restorer.
  if (authStatus === 'pending') {
    // Restore not settled yet: render nothing rather than flash a redirect.
    return null;
  }

  if (authStatus === 'unauthenticated') {
    return <Navigate to={ERoutesRoot.Login} replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
